import Backbone from 'backbone';
import { EmptyObject } from '@ve/types/EmptyObject';
import { directFlights, DirectFlight } from './directFlights';

export default (tourCriteria: Backbone.Model): DirectFlight | EmptyObject => ({
        ...directFlights(tourCriteria),
});